import { AuthenticationProvider, AuthenticationProviderOptions } from "@microsoft/microsoft-graph-client";
import AzureTokenService from "./services/AzureTokenService";

class OnBehalfOfAuthenticationProvider implements AuthenticationProvider {
    private accessToken?: string;
    private timer?: NodeJS.Timeout;

    async getAccessToken(_?: AuthenticationProviderOptions): Promise<string> {
        if (this.accessToken) {
            return this.accessToken!;
        }

        const result = await AzureTokenService.tryGetUserToken();
        this.accessToken = result.data?.accessToken!;

        this.setTimer(result.data?.expiresIn ?? 5 * 60);

        return this.accessToken!;
    }

    private setTimer(expiresInSec: number) {
        if (this.timer) {
            clearInterval(this.timer);
        }

        this.timer = setInterval(async () => {
            const result = await AzureTokenService.tryGetUserToken();
            this.accessToken = result.data?.accessToken!;
            this.setTimer(result.data?.expiresIn ?? 5 * 60);
        }, expiresInSec * 1000 + 1000);
    }
}

export default new OnBehalfOfAuthenticationProvider();
